import {Sentence} from '$lib/classes/data/sentence';
import type {SentenceId, WordId} from '$lib/classes/data/_primitives';

export class SentenceManager {
    private wordIdToSentences: Record<WordId, Sentence[]> = {}
    private sentenceIdToSentence: Record<SentenceId, Sentence> = {};

    constructor() { }

    setSentences(sentences: Sentence[]): void {
        this.sentenceIdToSentence = sentences.reduce((dict, sentence) => {
            if (dict[sentence.id]) {
                console.error('SentenceManager: Two sentences with the same id found: ' + sentence.id)
                return dict
            }
            dict[sentence.id] = sentence;
            return dict
        }, {} as Record<SentenceId, Sentence>);

        sentences.forEach(sentence => {
            sentence.wordLinks.forEach(wordLink => {

                let id = wordLink.id
                if (id === null) return

                const hasTranlation = wordLink.t !== '-'
                const justOneOccurence = sentence.countOccurence(wordLink) === 1
                const notDisabled = wordLink.i !== -1

                if (hasTranlation && justOneOccurence && notDisabled) {

                    let entry = this.wordIdToSentences[id]

                    if (entry) {
                        this.wordIdToSentences[id] = [...this.wordIdToSentences[id], sentence]
                    } else {
                        this.wordIdToSentences[id] = [sentence]
                    }
                }
            })
        })
    }

    getSentence(sentenceId: SentenceId): Sentence | undefined {
        return this.sentenceIdToSentence[sentenceId]
    }

    getSentencesWithFirstSentence(wordId: WordId, sentenceId: SentenceId | null): Sentence[] {

        const sentences = this.getSentences(wordId)

        if (sentenceId === null) return sentences

        const index = sentences.findIndex(sentence => sentence.id === sentenceId)
        if (index === -1) {
            console.error('ERROR SentenceManager.getSentencesWithFirstSentence() - no sentence with provided Id found!')
            return sentences
        }

        const sentenceToMove = sentences[index]
        return [sentenceToMove, ...sentences.slice(0, index), ...sentences.slice(index + 1)]
    }

    getSentences(wordId: WordId): Sentence[] {
        return Sentence.sortByIndex(this.wordIdToSentences[wordId] ?? [], wordId)
    }

    getFirstSentence(wordId: WordId): Sentence | undefined {
        return this.getSentences(wordId)[0]
    }

    getNextSentence(wordId: WordId, currentSentenceId: SentenceId | null): Sentence | undefined {
        const sentences = this.getSentences(wordId);
        if (sentences.length <= 1) {
            return undefined;
        }
        const indexOfCurrentSentence = sentences.findIndex(sentence => sentence.id === currentSentenceId);
        if (indexOfCurrentSentence === -1) {
            return undefined
        } else {
            const nextIndex = (indexOfCurrentSentence + 1) % sentences.length;
            return sentences[nextIndex];
        }
    }

    getSentencePositionInfo(wordId: WordId, sentenceId: SentenceId): string | undefined {
        const sentences = this.getSentences(wordId);
        const index = sentences.findIndex(sentence => sentence.id === sentenceId);
        if (index === -1) {
            console.error(`ERROR could not get sentence position for sentence ${sentenceId} of ${wordId}`)
            return undefined
        }
        const isOnlySentence = sentences.length === 1;
        return isOnlySentence ? undefined : `${index + 1} / ${sentences.length}`;
    }
}